(function($){
    $(document).ready(function() {

        $('.js-gallery').find('.fancybox').fancybox({
            openEffect	: 'none',
            closeEffect	: 'none',
            loop : false,
            beforeShow : function(){
                this.title = $(this.element).find('.slider-caption').html();
            },
            helpers: {
                title : {
                    type : 'inside'
                }
            }
        });

    });
})(jQuery);